import { DeleteTwoTone } from '@mui/icons-material';
import { Box, Button, CardContent, Dialog, DialogActions, DialogTitle, Divider, IconButton, Typography } from '@mui/material'
import Input from '@mui/material/Input';
import { GoogleLogout } from 'react-google-login';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import React, { Component } from 'react'
import { SidebarWidth } from '../Settings'
import { getURLBase } from '../utils/helperFns';
import axios from 'axios';

export class Profile extends Component {
    constructor(props) {
        super(props);
        this.url = getURLBase(true) + "/user";
        this.state = {
            isReady: false,
            showDeleteMyDataDialog: false,
            showDeleteAccountDialog: false,
            showProfileDialog: false,
            name: '',
            nameValue: "",
            email: '',
        };
    }

    componentDidMount() {
        axios.post(this.url, { gid: this.props.gid }).then(
            (response) => {
                this.setState({
                    name: response.data.body.name,
                    email: response.data.body.email,
                    nameValue: response.data.body.name,
                    dialog: response.data.body.dialog,
                    isReady: true
                })
            }
        )
    }

    logout = () => {
        window.location.href = "/home"

        this.props.logout();
    }

    openProfileDialog = () => {
        this.setState({ showProfileDialog: true });
    };
    
    closeProfileDialog = () => {
        this.setState({ showProfileDialog: false });
    };
    openDeleteMyDataDialog = () => {
        this.setState({ showDeleteMyDataDialog: true });
    }
    closeDeleteMyDataDialog = () => {
        this.setState({ showDeleteMyDataDialog: false });
    }

    closeDeleteAccountDialog = () => {
        this.setState({ showDeleteAccountDialog: false });
    }
    
    openDeleteAccountDialog = () => {
        this.setState({ showDeleteAccountDialog: true });
    }

    deleteUser = () => {
        let delUrl = getURLBase(true) + "/deleteuser";
        axios.post(delUrl, { gid: this.props.gid }).then(
            (response) => {});
        this.closeDeleteAccountDialog();
        this.setState({ showDeleteAccountDialog: false });
        this.props.logout();
    }

    saveName = () => {
        var s = this.state;
        this.setState({ name: s.nameValue });
        this.closeProfileDialog();
    }

    render() {
        return (
            <Box className="dashboard-wrapper" sx={{ flexGrow: 1 }}>
            <Box id="profile-box" padding={{xs:"1.5rem 1rem",sm:"2rem 8rem"}} marginLeft={{xs:0,sm:`${SidebarWidth}px`}} sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                

                <Divider light />

                <Box sx={{ marginBottom: "70px", marginTop: "20px" }}>
                    <Typography variant="h5" sx={{ fontFamily: "Nunito Sans", fontWeight: 700, marginBottom: "20px" }}>Delete Account</Typography>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="subtitle1" sx={{ marginRight: "25px" }}>
                        {this.state.isReady ? this.state?.dialog?.title : ""}
                        </Typography>
                        <DeleteTwoTone sx={{ cursor: "pointer" }} onClick={this.openDeleteAccountDialog} />
                    </Box>
                </Box>
                <Box>
                    <Typography variant="h5" sx={{ fontFamily: "Nunito Sans", fontWeight: 700, marginBottom: "10px" }}>Contact Us</Typography>
                    <Typography variant="subtitle1">hello@wyzr.uk</Typography>
                </Box>
                <br /><br />
                <GoogleLogout buttonText="Logout" onLogoutSuccess={this.logout} style={{ width:50, height:50 }} />
                <br /><br /><br />
                
                <Dialog maxWidth="md" open={this.state.showDeleteMyDataDialog}>
                    <DialogTitle sx={{ fontSize: "1rem" , display:"flex", alignItems:"flex-start", justifyContent:"space-between"}}>
                        {this.state.isReady ? this.state?.dialog?.message : ""}
                        <IconButton
                            aria-label="close"
                            onClick={this.closeDeleteMyDataDialog}
                            sx={{
                                padding:0,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseRoundedIcon />
                        </IconButton>
                    </DialogTitle>


                    <Divider light />
                    <CardContent>
                        <Typography variant="body2" color="textSecondary" component="p" sx={{ fontSize: "1rem" }}>
                        {this.state.isReady ? this.state?.dialog?.content : ""}
                        </Typography>
                    </CardContent>

                    <DialogActions>
                        <Button onClick={this.closeDeleteMyDataDialog} autoFocus sx={{ fontSize: "1rem" }}>
                            Yes
                        </Button>
                        <Button onClick={this.closeDeleteMyDataDialog} sx={{ fontSize: "1rem" }}>No</Button>
                    </DialogActions>

                </Dialog>
                <Dialog maxWidth="md" open={this.state.showDeleteAccountDialog}>
                    <DialogTitle  sx={{ fontSize: "1rem" , display:"flex", alignItems:"flex-start", justifyContent:"space-between"}}>
                        Are you sure you want to unlink your account from Wyzr?
                        <IconButton
                            aria-label="close"
                            onClick={this.closeDeleteAccountDialog}
                            sx={{
                               padding:0,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseRoundedIcon />
                        </IconButton>
                    </DialogTitle>

                    <Divider light />
                    <CardContent>
                        <Typography variant="body2" color="textSecondary" component="p" sx={{ fontSize: "1rem" }}>
                            You will no longer be able to view any data on Wyzr if you go ahead. You will be able to sign up again.
                        </Typography>
                    </CardContent>

                    <DialogActions>
                        <Button onClick={this.deleteUser} autoFocus sx={{ fontSize: "1rem" }}>
                            Yes
                        </Button>
                        <Button onClick={this.closeDeleteAccountDialog} sx={{ fontSize: "1rem" }}>No</Button>
                    </DialogActions>

                </Dialog>

                <Dialog maxWidth="md" open={this.state.showProfileDialog}>
                    <DialogTitle  sx={{ fontSize: "1rem" , display:"flex", alignItems:"flex-start", justifyContent:"space-between"}}>
                            Name
                        <IconButton
                            aria-label="close"
                            onClick={this.closeProfileDialog}
                            sx={{
                               padding:0,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseRoundedIcon />
                        </IconButton>
                    </DialogTitle>

                    <Divider light />
                    <CardContent>
                    <Box className="flex-center-all" mt={2} mb={1} sx={{ justifyContent: "flex-start !important" }}>
                        <Input defaultValue={this.state.name} sx={{ fontSize: "inherit", fontWeight: 700 ,flex:1.8}} onChange={(e) => this.setState({ nameValue: e.target.value })} />
                    </Box>
                    </CardContent>

                    <DialogActions>
                        <Button onClick={this.closeProfileDialog} autoFocus sx={{ fontSize: "1rem" }}>
                            Discard
                        </Button>
                        <Button onClick={() => this.saveName()} sx={{ fontSize: "1rem" }}>Save</Button>
                    </DialogActions>

                </Dialog>
            </Box>
            </Box>
        )
    }
}

export default Profile
